export const themeConstants = {
	GET_THEME_SETTINGS_REQUEST: 'GET_THEME_SETTINGS_REQUEST',
	GET_THEME_SETTINGS_SUCCESS: 'GET_THEME_SETTINGS_SUCCESS',
	GET_THEME_SETTINGS_FAILED: 'GET_THEME_SETTINGS_FAILED',
};
